import EventEmitter from '../Utils/EventEmitter';
import Utils from '../Utils/Utils';

export default class MediaPlayer extends EventEmitter {

    constructor(player, sdk) {
        super();
        this.sdk = sdk
        this.player = player;
        this._stopAt = false;
        this._startAt = false;
        this.pastilles = [];
        this.width;
        this.height;
        this.seekRange = {
            start: 0,
            end: 0
        }
        this.ratioBando;
        this.dataTime;
        if (window.live)
            this.dvrLive = this.player.getConfig().dvrLive;

        this.last = 0;

        /*setInterval(() => {
            console.log('TIME', this.getCurrentTime(), this.seekRange.end, this.player.getConfig().dvrSeekLimit, (this.seekRange.end +  this.getCurrentTime()));
        }, 4000)*/
        

        if (window.local) {
            this.listenLocal();
        }
        else {
            this.listenJW();

        }
    }

    listenLocal() {

        this.player.ontimeupdate = () => {
            let now = new Date().getTime();
            let diff = now - this.last;
            if (diff < 500) {
                return;
            }
            this.last = now;
            this.sdk.findCurrentChapter(this.player.currentTime);
        }
        this.player.onloadedmetadata = (e) => {
            this.addSpeakerBandeau();
        }
    }

    listenJW() {
		
		
		
        this.player.on('time', (data) => {
            let now = new Date().getTime();
            let diff = now - this.last;
            if (diff < 500) {
                return;
            }
            this.dataTime = data;
            this.last = now;
            if (window.live) {
                //console.log(data);
                this.seekRange = data.seekRange;
                this.sdk.live.liveCuepointsManager.findLiveCurrents(data.currentTime); //Chapter(data.currentTime);

                if (this.dvrLive != this.player.getConfig().dvrLive) {
                    this.dvrLive = this.player.getConfig().dvrLive;
                    this.sdk.emit('dvrLiveChanged', this.dvrLive);
                }

                if (this._stopAt !== false) {
                    if (data.currentTime > this._stopAt)
                        this.player.stop();
                }

                if (this._startAt !== false) {
                    if (data.currentTime < this._startAt)
                        this.player.seek(this._startAt);
                }

                this.sdk.live.liveCuepointsManager.processBuffer(this.getRealDuration()) //data.currentTime);
            }
            else
                this.sdk.findCurrentChapter(data.currentTime);
			
			
					
			
			window.sdk.emit('seeked');
        });
		
		setInterval(() => {
			//if(window.portraitMode) {
				try {
					if(!document.querySelector('.tab-odj-block').classList.contains('hide'))
						document.querySelector('.tab-extract-block').style.display = 'none';
					else {
						if(document.querySelector('.tab-extract-block'))
							document.querySelector('.tab-extract-block').style.display = 'block';
					}
				}
				catch(err) {
				
				}
				if(window.portraitMode === false) {
					try {
						document.querySelector('.tab-extract-block').style.display = 'block';
					}
					catch(err) {
					}
				}
			//}
			//else {
			//	if(document.querySelector('.tab-extract-block'))
			//		document.querySelector('.tab-extract-block').style.display = 'block';
			//}
			
				/*try {
					if(!this.scrolled) {						
						//document.querySelector('.tab-odj-block').scrollTo						
						let el = document.querySelector('.chapter-current');
						console.log('scroll', el.offsetTop - 50, this.scrolled);
						document.querySelector('.odj').scrollTop = el.offsetTop - 50;
					}
				}
				catch(err) {
					//console.error(err);
				}*/
				
		}, 1000);

        this.player.on('play', (e) => {
            let el = document.querySelector('video');
            this.ratio = el.videoWidth / el.videoHeight;
            /*alert(el.videoWidth +' , ' + el.offsetHeight)
                    this.width = el.offsetWidth * ratio;
                    this.height = el.offsetHeight / ratio;
                //}
            alert(this.width + ' - ' + this.height)*/
            this.addSpeakerBandeau();
        });

        this.player.on('meta', (e) => {

            if (e['metadata'] && e['metadata']['TXXX'] && e['metadata']['TXXX']['onCuepointMetadata']) {
                let metadata = JSON.parse(e['metadata']['TXXX']['onCuepointMetadata']);
                //metadata.action = 'chapter';
                metadata.live_second = e.metadataTime
                console.log(metadata);

                this.sdk.live.liveCuepointsManager.addAction(metadata)
            }

            if (e.metadataType == 'media') {
                
                /*if(e.width) {
                    this.width = e.width;
                    this.height = e.height;
                }
                else {*/
                
            }
            //console.log(e);
        })
        
        this.player.on('seek', (e) => {
            console.log('seek');
        });

        this.player.on('fullscreen', (e) => {
            setTimeout(() => {
                this.moveBandeau();
            }, 300)
        });
		
		//this.checkScroll()
		
    }
	
	async checkScroll() {
		this.scrolled = false;
		
		while(!document.querySelector('.odj')) {
			console.log('on attend odj');
			await Utils.sleep(1000);
		}
		document.querySelector('.odj').addEventListener("scroll", (event) => {
			if(this.scrollTimeout)
				clearTimeout(this.scrollTimeout);			
			console.log('manual scroll');
			this.scrolled = true;
			this.scrollTimeout = setTimeout(() => {
				this.scrolled = false;
			}, 5000);
		});
	}

    showTime() {
        console.warn({
            dataTime: this.dataTime,
            getRealDuration: this.getRealDuration(),
            getCurrentTime: this.getCurrentTime(),
            dvrSeekLimit: this.player.getConfig().dvrSeekLimit,
            seekRange: this.seekRange,
            config: this.player.getConfig()
        })
    }

    async addSpeakerBandeau() {
        if (!document.getElementById('speaker_bandeau')) {
            var node = document.createElement("div");
            node.classList.add('speaker_bandeau');
            node.id = 'speaker_bandeau';
            let style;
            if (window.custom) {
                
                let addStyle = [];
                let speakerInner = '';
                if(window.custom.synople.speaker_typo_name)
                    addStyle.push('font-family: ' + window.custom.synople.speaker_typo_name );
                if(window.custom.synople.speaker_color_txt)
                    addStyle.push('color: ' + window.custom.synople.speaker_color_txt );
                if(window.custom.synople.speaker_padding)
                    speakerInner = '.speaker_inner { padding-left: ' + window.custom.synople.speaker_padding + ' } ';
                
                style = '<style>#speaker_bandeau { background-image:url(\'' + window.custom.synople.image_speaker + '\'); background-color:' + window.custom.synople.speaker_color + '; ' + addStyle.join(';') + '} ' + speakerInner + '}</style>'
            }
            node.innerHTML = '<div class="speaker_inner"><p id="speaker_name">Nom Prénom</p><p id="speaker_function">Function</p></div>' + style;
            while(!document.querySelector('.jw-controls')) {
                await Utils.sleep(300);
            }
            let ctrl = document.querySelector('.jw-controlbar');
            document.querySelector('.jw-controls').insertBefore(node, ctrl);
            this.moveBandeau()
            window.onresize = () => {
                this.moveBandeau();
            };
        }
    }

    moveBandeau() {
        let w = document.getElementById('player').offsetWidth;
        let h = document.getElementById('player').offsetHeight;

        let ratioVideo = this.ratio; //this.width / this.height;
        let ratioPlayer = w / h;
        let realW, realH, top, left;
        this.ratioBando = 794 / 60;
        if (ratioPlayer < ratioVideo) {
            realW = w;
            realH = w / ratioVideo;
            left = 0;
            document.getElementById('speaker_bandeau').style.height = Math.floor(realW / this.ratioBando) + 'px';
            top = (h / 2) + (realH / 2) - (document.getElementById('speaker_bandeau').offsetHeight * 1.5);
            //console.log('a, ' + top)
        }
        else {
            realW = h * ratioVideo;
            realH = h;
            left = (w / 2) - (realW / 2);
            document.getElementById('speaker_bandeau').style.height = Math.floor(realW / this.ratioBando) + 'px';
            top = realH - document.getElementById('speaker_bandeau').offsetHeight;
            //console.log('b, ' + top)
        }
        if (h - realH < 20) {
            top = top - (30 - (h - realH));

        }
        
        //console.log('c, ' + top)
        
        document.getElementById('speaker_bandeau').style.top = top + 'px';
        document.getElementById('speaker_bandeau').style.left = left + 'px';
        document.getElementById('speaker_bandeau').style.width = Math.ceil(realW) + 'px';
        
        
        
        //alert('ok ' + Math.ceil(realW) + ' - ' + document.getElementById('speaker_bandeau').style.height);
        
    }


    friendlyDate(s) {
        let nbS = s / 60
        if (nbS < 1) {
            return '< 1 min.';
        }
        else if (nbS < 3600) {
            return Math.round(nbS / 60) + ' min.';
        }
        else {
            let h = nbS / 3600;

            return 'Il y a ' + Math.round(nbS / 60) + ' minutes';
        }
    }

    stop() {
        if (window.local)
            this.player.pause();
        else
            this.player.stop();

    }

    seek(time) {
        if (window.local)
            this.player.currentTime = time;
        else {
            this.player.seek(time);

        }
    }

    getCurrentTime() {
        return (window.local) ? this.player.currentTime : this.player.getPosition();
    }

    getRealDuration() {
        let res = this.getCurrentTime()
        if (res < 0) {
            if (this.isLive())
                res = this.seekRange.end + this.getCurrentTime();
            else
                res = this.seekRange.end - this.player.getConfig().dvrSeekLimit;
            //console.log('getRealDuration', this.seekRange.end, this.player.getConfig().dvrSeekLimit, res);
        }
        return res;
    }

    getTotalDuration() {
        return (window.local) ? this.player.duration : this.player.getDuration();
    }

    forward(time) {
        this.seek((this.getCurrentTime() + parseInt(time)));
    }

    rewind(time) {
        this.seek((this.getCurrentTime() + parseInt(time)));
    }

    reload() {
        console.log('reload', this.sdk.live.streamUrl)
        this.player.load({
            file: this.sdk.live.streamUrl
        });
        this.player.play();
    }

    startAt(t) {
        this.player.on('firstFrame', () => {
            this.player.seek(t);
        });
        this._startAt = t;
    }

    stopAt(t) {
        this._stopAt = parseInt(t);
    }

    addChapterExceededTime(elName, s) {
        this.pastilles.push({
            name: elName,
            second: s
        })
    }

    isLive() {
        if (this.player.getConfig().streamType == 'LIVE')
            return true;
        if (this.dvrLive == undefined)
            return -1;
        return this.dvrLive;
    }

    isDVR() {
        if (this.player.getConfig().streamType != 'DVR')
            return false;
        else
            return true;
    }

    isVOD() {
        if (this.player.getConfig().streamType != 'VOD')
            return false;
        else
            return true;
    }

    getState() {
        return this.player.getState()
    }
    
    destroy() {
        return this.player.remove()
    }

}



// WEBPACK FOOTER //
// ./src/Sdk/MediaPlayer.js